import logo from '../../assets/icons/ivyLeagueLogo.png'
import { useEffect } from 'react'
import { StepsIndicator } from '../../components/IvyLeague/StepsIndicator/StepsIndicator'
import { Footer } from '../../components/IvyLeague/Footer/Footer'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../redux'
import { Step1 } from '../../components/IvyLeague/Steps/Step1/Step1'
import { Step2 } from '../../components/IvyLeague/Steps/Step2/Step2'
import { Step3 } from '../../components/IvyLeague/Steps/Step3/Step3'
import { Step4 } from '../../components/IvyLeague/Steps/Step4/Step4'
import axios from 'axios'
import ivyLeagueSlice from '../../redux/slice/ivyLeague.slice'
import appSlice from '../../redux/slice/app.slice'
import { config } from '../../config'

const IvyLeague = () => {
  const dispatch: AppDispatch = useDispatch()
  const { step } = useSelector((state: RootState) => state.ivyLeague)
  const { isLoading } = useSelector((state: RootState) => state.app)

  const renderRespectiveStep = () => {
    if (step === 1) return <Step1 />
    if (step === 2) return <Step2 />
    if (step === 3) return <Step3 />
    if (step === 4) return <Step4 />
    return null
  }

  const fetchPricingConfig = async () => {
    if (!config.ivyLeagueSpreadsheetUrl || !config.ivyLeagueApiKey) {
      console.error('Ivy League configuration is missing from environment')
      return
    }
    dispatch(appSlice.actions.setLoading(true))
    try {
      const response = await axios({
        url: config.ivyLeagueSpreadsheetUrl,
        method: 'GET',
        params: { apiKey: config.ivyLeagueApiKey }
      })

      if (
        response.data?.msg === 'Incorrect api key' ||
        (response.status !== 200 &&
          response.statusText !== 'OK' &&
          !response?.data?.success)
      ) {
        console.error('Error getting Ivy League pricing', response.data)
        throw new Error(`Error getting Ivy League pricing: ${response.data as string}`)
      }

      const pricingConfiguration = response.data
      if (pricingConfiguration) {
        dispatch(ivyLeagueSlice.actions.setAdminConfiguration(pricingConfiguration))
      }
    } catch (error) {
      console.error(error)
      throw error
    } finally {
      dispatch(appSlice.actions.setLoading(false))
    }
  }

  useEffect(() => {
    fetchPricingConfig()
  }, [])

  return (
    <div className="ivyLeague">
      <div className="contentArea">
        <div className="title">
          <img src={logo} className="logo" alt="Ivy League" />
          Ivy League Tuition Calculator
        </div>
        <StepsIndicator />
        <div className="stepsContainer">
          {renderRespectiveStep()}
        </div>
        <Footer />
      </div>
      {isLoading && (
        <div className="loadingPanel">
          <div className="lds-ripple"><div></div><div></div></div>
        </div>
      )}
    </div>
  )
}

export default IvyLeague
